<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
</ng-template>

<ng-template #content>
  <div class="panel">

    <app-list-item *ngFor="let item of footerItems" (click)="navigate(item.route)" showActionIcon="true"
      title="{{ item.displayNameTranslation | translate }}" showItemStatus="true"
      [itemStatusIcons]="getIconStatus(item.iconName)">
    </app-list-item>
  </div>
</ng-template>

<!-- Log out / go back to local button is always displayed at the bottom -->
<ng-container *ngIf="isXpact">
  <app-list-item (click)="onBackToLocalClick()" [disabled]="isStoppingImpersonation"
    title="{{ 'Modules.More.GoBackToLocal' | translate }}" showItemStatus="false" [itemStatusIcons]="getIconStatus('logout')">
  </app-list-item>
</ng-container>

<ng-container *ngIf="!isXpact">
  <app-list-item (click)="onLogoutClick()" [disabled]="isStoppingImpersonation"
    title="{{ 'Modules.More.Logout' | translate }}" showActionIcon="true" showItemStatus="true"
    [itemStatusIcons]="getIconStatus('logout')">
  </app-list-item>
</ng-container>